import bulkImportPriceList from '@/api/post/company/company-price/bulk-import-price-list';
import bulkImportDealerPriceList from '@/api/post/dealer/bulk-import-dealer-price-list';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import { Row } from '@/components/grid/grid-component';
import Loader from '@/components/loader/loader-component';
import { useMutation } from '@/hooks/use-api';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import Swal from 'sweetalert2';
import CreatePricingModal from './create-pricing-modal';
import './swal.css';

const swalDivStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  width: '90%',
  flexDirection: 'column',
};

const rowStyle = {
  marginLeft: '0px',
  marginRight: '0px',
  marginBottom: '40px',
  marginTop: '0px',
};

/**
 * Create a pricing wrapper
 * @param {object} root0 - props
 * @param {Function} root0.setOpenCreateModal - Function to set the open state of the create modal
 * @param {string} root0.companyId - companyId passed either selectedSupplier or Company;
 * @param {bool} root0.isDealer - if company is a dealer;
 * @param {Function} root0.refetch - Function to refetch the table data
 * @returns {JSX.Element}
 */
const CreatePricingWrapper = ({
  isDealer,
  companyId,
  setOpenCreateModal,
  refetch,
}) => {
  const [importBulkDealerPriceList, { loading: loadingImportDealer }] =
    useMutation(bulkImportDealerPriceList);

  const [importBulkPriceList, { loading: loadingImportCompany }] =
    useMutation(bulkImportPriceList);

  const submitForm = (values) => {
    if (isDealer) {
      importBulkDealerPriceList(values, companyId).then((res) => {
        setOpenCreateModal(false);
        Swal.fire({
          title: 'Bulk import Results',
          html: ReactDOMServer.renderToString(
            <div style={swalDivStyle}>
              <ul>
                <li>{res.data.added} new components have been added.</li>
                <li>{res.data.removed} components have been removed.</li>
                <li>{res.data.updated} components have been updated.</li>
              </ul>
            </div>,
          ),
          showCloseButton: true,
          confirmButtonText: 'ok',
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.isConfirmed) {
            refetch();
          }
        });
      });
    } else {
      importBulkPriceList(values, companyId).then((res) => {
        setOpenCreateModal(false);
        Swal.fire({
          title: 'Bulk import Results',
          html: ReactDOMServer.renderToString(
            <div style={swalDivStyle}>
              <ul>
                <li>{res.data.added} new components have been added.</li>
                <li>{res.data.removed} components have been removed.</li>
                <li>{res.data.updated} components have been updated.</li>
              </ul>
            </div>,
          ),
          showCloseButton: true,
          confirmButtonText: 'ok',
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.isConfirmed) {
            refetch();
          }
        });
      });
    }
  };

  return (
    <FormWrapper
      defaultValues={{
        file_name: '',
        end_user_gross_profit: 0,
        transfer_price_gross_profit: 0,
        remove_missing_part_numbers: false,
        remove_temporary_part_numbers: false,
      }}
      onSubmit={(values) => {
        submitForm(values);
      }}
    >
      {loadingImportCompany || loadingImportDealer ? (
        <Row style={rowStyle} justify="center">
          <Loader loading loadingText="...Loading" />
        </Row>
      ) : (
        <CreatePricingModal
          companyId={companyId}
          onClose={setOpenCreateModal}
        />
      )}
    </FormWrapper>
  );
};

CreatePricingWrapper.defaultProps = {
  setOpenCreateModal: () => {},
  refetch: () => {},
  companyId: '',
  isDealer: false,
};

CreatePricingWrapper.propTypes = {
  setOpenCreateModal: PropTypes.func,
  refetch: PropTypes.func,
  companyId: PropTypes.string,
  isDealer: PropTypes.bool,
};
export default CreatePricingWrapper;
